interface DateDividerProps {
  date: string;
}

const DateDivider = ({ date }: DateDividerProps) => {
  return (
    <div className="flex items-center justify-center my-4">
      <div className="bg-white/90 backdrop-blur-sm shadow-sm rounded-full px-4 py-1.5 border border-gray-200">
        <span className="text-xs font-medium text-gray-600">{date}</span>
      </div>
    </div>
  );
};

export default DateDivider;
